import axios from 'axios';
import tokenService from './tokenService';
import setError from '@/store/mutations/RootStateMutations';

const { VUE_APP_API_BASE_URL, VUE_APP_LOGIN_REDIRECT_URL } = process.env;

axios.interceptors.request.use((config: any) => {
   if (tokenService.getToken()) {
     config.headers.common.Authorization = `Bearer ${tokenService.getToken()}`;
   }
   return config;
});

const interceptor = axios.interceptors.response.use(
  response => response,
  error => {
      if (error.response.status !== 401) {
          return Promise.reject(error);
      }

      axios.interceptors.response.eject(interceptor);

      tokenService.clearToken();

     // location.reload();

      // if (VUE_APP_LOGIN_REDIRECT_URL) {
      //   location.href = VUE_APP_LOGIN_REDIRECT_URL;
      // } else {
      //   location.reload();
      // }
  },
);

axios.defaults.timeout = 60000;

export default {
  async login(accessKey: string): Promise<LoginResponse> {
    const response = await axios.post<LoginResponse>(`${VUE_APP_API_BASE_URL}/api/login`, {
      accessKey,
    });
    return response.data;
  },

  async searchitems(request: SearchItemRequest) {
    const response  = await axios.post(`${VUE_APP_API_BASE_URL}/api/searchby/textfilter`,
    {
      ...request,
    });
    return response.data;
  },

  async getCompanies(ids: string[]): Promise<Company[]> {
    const response = await axios.post(`${VUE_APP_API_BASE_URL}/api/nameresolver/empresa`, ids);
    return response.data as Company[];
  },

  async getItemTypes(ids: string[]): Promise<ItemType[]> {
    const response = await axios.post(`${VUE_APP_API_BASE_URL}/api/nameresolver/tipo`, ids);
    return response.data as ItemType[];
  },

  async getCategories(ids: number[]): Promise<Category[]> {
    const response = await axios.post(`${VUE_APP_API_BASE_URL}/api/nameresolver/categorias`, ids);
    return response.data as Category[];
  },
};

interface LoginResponse {
  name: string;
  token: string;
}

interface SearchItemRequest {
  Search: string;
  Language: string;
  SearchSize: number;
  searchType: string;
}

export interface Company {
  id: string;
  name: string;
}

export interface ItemType {
  id: string;
  description: string;
}

export interface Category {
  idCateg: number;
  idCampo: number;
  idPai: number | null;
  nivel: number;
  grupo: string;
  campo: string;
  codigoValor: string;
  descricao: string;
}
